import Api from './PhiApi'
import CONSTANTS from './Constants'

export default class PhiEvent {

    constructor(options) {
        this.phiRef = options

        this.fetchProgramList = function* (that, config) {
            let token = that.phiRef.getSession()
            
            if (Boolean(token) && Boolean(token.jwt)) {
                let roleId = that.phiRef.User.roles()[0].role_type_id
                config.orgActive = CONSTANTS.roles[roleId].orgActive[config.orgType]
                let response = yield Api.fetchProgramList(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.getProgram = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                const { id } = config
                let response = yield Api.getProgram(id)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    const details = JSON.parse(response.data.results[0].billingjson)

                    if (details.org.organization && details.org.organization.length) {
                        let program = details.org.organization[0].billing 
                        program = program ? [program] : null
                        let events = details.org.organization[0].events
                        delete details.org.organization[0].billing
                        delete details.org.organization[0].events
                        let orgDetails = details.org.organization[0]
                        let history = details.org.organization[0].history 
                        history = history && history.length ? history : null
                        
                        return {program, events, orgDetails, history}
                    } else {
                        return null
                    }
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.addProgram = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.addProgram(config)
                
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.editProgram = function* (that, config) {
            let token = that.phiRef.getSession()
            
            if (Boolean(token.jwt)) {
                let response = yield Api.editProgram(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.updateEventTrack = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                const {trackId, payload} = config
                let response = yield Api.updateEventTrack(trackId, payload)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return {error: response.problem}
                }                    
            }
            return null
        }
    }
}